import React from 'react';
import { FpHeader } from 'components/organisms/FpHeader';
import { FpNotificationGroup } from 'components/organisms/FpNotificationGroup';
import { FpNotificationData } from 'components/molecules/FpNotification';
import { LoginUser } from 'types/model/user';
import { ServiceProjectPolicyResponse } from 'types/entity';

export interface FpLayoutProps {
  userName: string
  companyName: string
  displayLocale: string
  zoneinfo: LoginUser['zoneinfo']
  projectName: string
  projectTypeName: string
  projectStatus: string
  projectId: string
  isProjectAdmin: boolean
  isFpReadableProject: boolean
  isFpEditableProject: boolean
  isEditableExtendedAttributeProject: boolean
  isDdmsReadableProject: boolean
  isPhotoReadableProject: boolean
  isProjectInvitationServiceAuth: boolean
  isGroupManagerServiceAuth: boolean
  serviceProjectPolicies: ServiceProjectPolicyResponse[]
  notifications: FpNotificationData[]
  onCloseNotification: (id: string) => void
  children: React.ReactNode
}

const FpLayout: React.FC<FpLayoutProps> = (props) => (
  <div>
    <FpHeader
      userName={props.userName}
      companyName={props.companyName}
      displayLocale={props.displayLocale}
      zoneinfo={props.zoneinfo}
      projectName={props.projectName}
      projectTypeName={props.projectTypeName}
      projectStatus={props.projectStatus}
      projectId={props.projectId}
      isProjectAdmin={props.isProjectAdmin}
      isFpReadableProject={props.isFpReadableProject}
      isFpEditableProject={props.isFpEditableProject}
      isEditableExtendedAttributeProject={props.isEditableExtendedAttributeProject}
      isDdmsReadableProject={props.isDdmsReadableProject}
      isPhotoReadableProject={props.isPhotoReadableProject}
      serviceProjectPolicies={props.serviceProjectPolicies}
      isProjectInvitationServiceAuth={props.isProjectInvitationServiceAuth}
      isGroupManagerServiceAuth={props.isGroupManagerServiceAuth}
    />
    <div className="contents">
      {props.children}
    </div>
    <FpNotificationGroup
      notifications={props.notifications}
      onClose={props.onCloseNotification}
    />
  </div>
);

export { FpLayout };
